<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Aprovações em Massa</h1>
                <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto" (click)="toggleFilters = !toggleFilters">
                    <mat-icon>tune</mat-icon>
                </button>             
            </div>

            <!-- BARRA DE PROGRESSO -->
            <div *ngIf="loading" class="mb-3">
                <mat-progress-bar mode="determinate" [value]="progressValue" color="primary"></mat-progress-bar>
                <div class="text-center text-muted mt-1">
                    <small>Processando: {{ progressValue }}%</small>
                </div>
            </div>

            <!-- FILTROS -->
            <form class="row align-items-center" name="form" (ngSubmit)="form.valid && save(form)" #form="ngForm" novalidate>
                <ng-collapse [toggle]="true">
                    <div class="border-top px-1 py-3">
                        <div class="row align-items-end">
                            <div class="col-12 col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Perfil Usuário</mat-label>
                                    <mat-select [(ngModel)]="filters.perfilUsuario" name="perfilUsuario" required>                                     
                                        <mat-option value="FUNCIONARIO">FUNCIONÁRIO</mat-option>
                                        <mat-option value="FISCAL">FISCAL</mat-option>
                                        <mat-option value="AFERIDOR">AFERIDOR</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div> 
                            <div class="col-12 col-md-6">
                                <ng-select name="user" [items]="usuario$ | async" required
                                    placeholder="Usuário" typeToSearchText="Buscar usuário..." notFoundText="Nenhum usuário encontrado" loadingText="Buscando..."
                                    [typeahead]="usuarioInput$" [(ngModel)]="user" [compareWith]="compareWith">
                                    
                                    <!-- selected -->
                                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                        <span class="ng-value-label">{{ item.firstName }} {{ item.lastName }}</span>
                                    </ng-template>

                                    <!-- lista -->
                                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                        <img class="rounded-circle me-2 img-cover" width="25" height="25" [src]="item.avatarUrl || 'assets/img/default_user.jpeg'" />
                                        <span>{{ item.firstName }} {{ item.lastName }}</span>
                                    </ng-template>                                    
                                </ng-select>
                            </div>
                            <div class="col-12 col-md-6">
                                <select-beneficiaria 
                                    [required]="true"
                                    [(ngModel)]="filters.beneficiaria"
                                    (beneficiariaChange)="setBeneficiaria($event)">
                                </select-beneficiaria>             
                            </div>                       
                            <div class="col-12 col-md-6">
                                <div class="d-flex">
                                    <mat-form-field class="flex-fill me-2">
                                        <mat-label>Inicio</mat-label>
                                        <input matInput [matDatepicker]="dataInicio" name="inicio" #inicio="ngModel"
                                            autocomplete="off" [(ngModel)]="filters.dataInicio" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="dataInicio"></mat-datepicker-toggle>
                                        <mat-datepicker #dataInicio></mat-datepicker>
                                    </mat-form-field>
                                    <mat-form-field class="flex-fill">
                                        <mat-label>Fim</mat-label>
                                        <input matInput [matDatepicker]="dataFim" name="fim" #fim="ngModel" autocomplete="off"
                                            [(ngModel)]="filters.dataFim" required>
                                        <mat-datepicker-toggle matIconSuffix [for]="dataFim"></mat-datepicker-toggle>
                                        <mat-datepicker #dataFim></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>                        
                            <div class="col-12 col-md-2 ms-auto">
                                <button mat-flat-button color="primary" class="btn-lg w-100" [disabled]="form.form.invalid || loading">
                                    <mat-spinner class="btn-spinner" *ngIf="loading"></mat-spinner>
                                    <span *ngIf="!loading">ATOCHAR</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-collapse>
            </form>     
            
        </mat-card-content>
    </mat-card>
</div>
